module.exports = fox._r("images/slides/urban/slide_2_3.jpg", __webpack_public_path__ + "images/slides/urban/slide_2_3.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/slides/urban/slide_2_3.jpg
// module id = 56
// module chunks = 2